<template>
  <div>
    <ModuleHeader>Ventas Modificador</ModuleHeader>
    <v-overlay v-if="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col md="12" cols="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="2" cols="12">
                <v-menu
                  v-model="menuFechaInicial"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="input_date"
                      label="Fecha Inicial"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="input_date"
                    @input="menuFechaInicial = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="2">
                <v-menu
                  v-model="menuFechaInicial2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="input_date_final"
                      label="Fecha Final"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="input_date_final"
                    @input="menuFechaInicial2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col v-if="false" md="2">
                <v-autocomplete
                  v-model="input_categoria"
                  label="Categoría del producto"
                  :items="categoriesList"
                  item-value="id"
                  item-text="label"
                >
                </v-autocomplete>
              </v-col>
              <v-col md="2">
                <v-autocomplete
                  label="Departamentos"
                  v-model="selectDep"
                  item-text="Nombre"
                  item-value="id"
                  :items="departamentos"
                ></v-autocomplete>
              </v-col>
              <v-col md="2">
                <v-switch label="Mostrar folios" v-model="showFolios">
                </v-switch>
              </v-col>
              <v-col class="text-right mt-n5" md="12">
                <v-btn
                  depressed
                  @click="cleanFilter()"
                  class="mx-2"
                  color="error"
                >
                  Restablecer Filtro
                </v-btn>
                <v-btn depressed @click="searchVentas()" color="success">
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12" cols="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="8"> Resultados </v-col>
              <v-col md="2" class="text-right">
                <v-btn
                  v-if="false"
                  @click="$router.push({ path: '/reportes/reportez' })"
                  color="primary"
                  dark
                  ><v-icon>mdi-file-document-outline</v-icon>
                  Reporte Z
                </v-btn>
              </v-col>
              <v-col md="2" class="text-right">
                <v-btn color="green" dark @click="exportExcel()"
                  ><v-icon>mdi-file-excel-box</v-icon>
                  Exportar a Excel
                  <!-- <download-excel
                    type="xls"
                    name="Ventas modificador"
                    :data="datos.processedData"
                  >
                  </download-excel> -->
                </v-btn>
              </v-col>
              <v-col md="12">
                <v-text-field v-model="filter" label="Filtrar"></v-text-field>
              </v-col>
            </v-row>
            <h3>Modificadores</h3>
            <v-simple-table v-if="render" dense>
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Modificador</th>
                  <th>Vendidos</th>

                  <th>Precio</th>
                  <th>Total</th>
                  <th v-if="showFolios">Folios</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="datos.processedData.length == 0">
                  <td colspan="16">No se encontraron datos</td>
                </tr>
                <template v-for="(prod, index) in dataProductos">
                  <tr :key="index">
                    <td>
                      {{ prod.Id == "Reserva" ? "TEE TIMES" : prod.Nombre }}
                    </td>
                    <td>
                      {{
                        prod.Id == "Reserva" ? "TEE TIMES" : prod.Modificador
                      }}
                    </td>
                    <td>
                      <b>{{ prod.Vendidos }}</b>
                    </td>

                    <td>
                      <b>{{ $pgsHelper.formatNumber(prod.Precio) }}</b>
                    </td>
                    <td>
                      <b>{{ $pgsHelper.formatNumber(prod.Total) }}</b>
                    </td>
                    <td v-if="showFolios">
                      <b>{{ prod.Tickets }}</b>
                    </td>
                  </tr>
                </template>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import "../../assets/css/sideBar.css";
import Cliente from "../../clases/Cliente.js";
import moment from "moment";
import Currency from "../../clases/Currencies.js";
import Membresia from "../../clases/Membresias/Membresia.js";
import Vue from "vue";
import GenericExcelExporter from "../../clases/ExcelMaker/GeneralExcel.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "VentasModificadores",
  components: {
    /*Select2,*/
  },
  props: ["hideMenu"],
  data() {
    return {
      selectDep: "ALL",
      currencyClass: Currency,
      menuFechaInicial: false,
      menuFechaInicial2: false,
      loadingData: false,
      render: true,
      showFolios: false,
      filter: "",
      datos: {
        all: [],
        processedData: [],
      },
      input_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      input_date_final: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      selectedRes: "",
      data_clientes: [],
      input_categoria: "ALL",
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      showModal: false,
      formKey: 0,
      data_ventas: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      data_cajas: [],
      reservations: [],
      cashiers: [],
      Categories: [],
      familias: [],
      header: [
        "Cliente",
        "Membresia",
        "Folio",
        "Familia",
        "Categoría",
        "Descripción",
        "Cantidad",
        "Total",
        "Método de pago",
        "Autorización",
        "Total",
        "Impuestos",
      ],
      processedData: [],
    };
  },
  computed: {
    ...mapGetters("Categorias", ["getCategoriesFiltered"]),
    dataProductos() {
      if (this.filter != "") {
        return this.datos.processedData.filter((acc) =>
          acc.Nombre.toUpperCase().includes(this.filter.toUpperCase())
        );
      }

      return this.datos.processedData;
    },
    categoriesList() {
      let categories = [{ id: "ALL", label: "TODOS" }];

      this.Categories.forEach((categoria) => {
        categories.push(categoria);
      });
      return categories;
    },
    Membresias() {
      return this.$pgsHelper.indexBy(Membresia.getMembresiasList(), "Id");
    },
    selectedReserva() {
      return this.selectedRes;
    },
    comp_clients() {
      let clientes = [];
      let rowclientes = this.$pgsHelper.indexBy(Cliente.getClientsList(), "Id");
      rowclientes.forEach((cli) => {
        clientes.push({ value: cli.Id, text: cli.getNombreCompleto(), ...cli });
      });
      return clientes;
    },
    comp_totales() {
      let total = {
        Cantidad: 0,
        Descuento: 0,
        Monto: 0,
        Subtotal: 0,
        Impuestos: 0,
      };
      this.datos.processedData.forEach((prod) => {
        total.Cantidad += Number(prod.Cantidad);
        let totalMonto = Number(prod.Subtotal) + Number(prod.Impuestos);
        total.Monto += Number(totalMonto);
        total.Descuento += Number(prod.Descuento);
        total.Subtotal += Number(prod.Subtotal);
        total.Impuestos += Number(prod.Impuestos);
      });
      return total;
    },
    departamentos() {
      let dep = [];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
  },
  methods: {
    exportExcel() {
      // Transformamos los datos antes de pasarlos al exportador
      const formattedData = this.datos.processedData.map((prod) => {
        return {
          Id: prod.Id,
          Categoria: prod.Categoria, // Asegurar que sea el Id de la Categoría
          Modificador: prod.Id === "Reserva" ? "TEE TIMES" : prod.Modificador,
          Nombre: prod.Id === "Reserva" ? "TEE TIMES" : prod.Nombre,
          Tickets: prod.Tickets ? prod.Tickets.join(", ") : "-",
          Vendidos: Number(prod.Vendidos),
          Precio: Number(this.$pgsHelper.formatNumber(prod.Precio)), // Formateamos como en la tabla
          Total: Number(this.$pgsHelper.formatNumber(prod.Total)), // Formateamos como en la tabla
        };
      });

      const options = {
        json_fields: {
          Id: "Id",
          Categoria: "Categoria",
          Modificador: "Modificador",
          Nombre: "Nombre",
          Tickets: "Tickets",
          Vendidos: "Vendidos",
          Precio: "Precio",
          Total: "Total",
        },
      };

      GenericExcelExporter.generateExcelBuffer(formattedData, options)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "Ventas Modificador.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => console.error("Error exportando Excel:", err));
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      await this.fetchCategories();
      const claims = this.$route.params?.user?.tokenResult?.claims;
      this.Categories = this.getCategoriesFiltered(claims);
    },
    processVentas() {
      console.time("ProcessVentas");
      let productosVenta = [];
      let productosModificadores = {};
      let productosSum = {};
      let ProductosTickets = [];
      this.datos.all.forEach((el) => {
        let pagos = Object.entries(el.Pagos);
        const map = new Map();
        let client = this.$pgsHelper.searchIndex(
          this.comp_clients,
          "Id",
          el.Cliente.Id
        );
        let idMembresia = client.ExtraData?.Membresia?.Membresia;
        let Membresia = this.$pgsHelper.searchIndex(
          this.Membresias,
          "Id",
          idMembresia
        );
        el.Catalogo.forEach((prod) => {
          try {
            let cantidad = prod.Cnt - (prod.Dto ? prod.Dto : 0);
            let cntpagos = Object.entries(prod.Pagos).reduce(
              (acum, curr) => acum + curr[1].cnt,
              0
            );
            let precio = 0;
            if (prod.Pagos) {
              Object.entries(prod.Pagos).forEach((pago) => {
                precio += pago[1].def.C;
              });
            }
            if (prod.Modificadores) {
              //
              prod.Modificadores.forEach((modi) => {
                let modificadorId = modi.Id;
                modi.sel.forEach((selection) => {
                  let modificadorId =
                    modi.Id +
                    "-" +
                    modi.Nombre +
                    "-" +
                    selection.nam +
                    "-" +
                    selection.idx;

                  if (!productosModificadores[modificadorId]) {
                    productosModificadores[modificadorId] = {
                      Categoria: prod.Categoria.I,
                      Modificador: modi.Nombre,
                      Nombre: selection.nam,
                      Tickets: [el.Folio],
                      Vendidos: selection.Cnt * cantidad,
                      Precio: selection.pco.C,
                      Total: Number(selection.Cnt * selection.pco.C * cantidad),
                      //Diff: cantidad - cntpagos,
                    };
                  } else {
                    productosModificadores[modificadorId].Vendidos +=
                      selection.Cnt * cantidad;
                    productosModificadores[modificadorId].Total += Number(
                      selection.Cnt * selection.pco.C * cantidad
                    );
                    productosModificadores[modificadorId].Tickets.push(
                      el.Folio
                    );
                  }
                });
              });
            }
          } catch (e) {
            console.log(e);
          }
        });
      });
      let preData = Object.entries(productosModificadores);
      let arrayData = [];
      preData.forEach((data) => {
        if (this.input_categoria !== "ALL") {
          if (data[1].Categoria == this.input_categoria) {
            arrayData.push({ Id: data[0], ...data[1] });
          }
        } else {
          arrayData.push({ Id: data[0], ...data[1] });
        }
      });
      arrayData = this.$_.orderBy(arrayData, "Vendidos", "desc");
      this.datos.processedData = arrayData;
      console.timeEnd("ProcessVentas");
    },
    cleanFilter() {
      this.input_date = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_date_final = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_folio = "";
      this.selectClient = "";
      this.selectDep = "ALL";
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas"
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getCashiers() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cashiers = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cashiers.push(toAdd);
          }
        });
      }
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getVentas() {
      const startDate = this.input_date;
      const endDate = this.input_date_final;
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("FechaVenta", ">=", startDate),
        firestore.where("FechaVenta", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ];

      //if (this.selectDep != "ALL") {
      filter.push(firestore.where("Departamento", "==", this.selectDep));
      //}

      if (this.input_folio != "") {
        filter.push(firestore.where("Folio", "==", this.input_folio));
      }

      if (this.selectClient != "") {
        filter.push(firestore.where("Cliente.Id", "==", this.selectClient));
      }

      const data = await firestore.queryBuilder("PDV_Ventas", filter);
      let preData = [];
      preData = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      preData.forEach((item) => {
        item.fecha = new moment(item.FechaCreacion).format("YYYY-MM-DD HH:mm");
      });

      preData = this.$_.orderBy(preData, "fecha", "desc");

      this.datos.all = preData;
    },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );

      this.familias = [];
      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    searchVentas() {
      Promise.resolve()
        .then(() => {
          this.loadingData = true;
        })
        .then(() => {
          return this.getVentas();
        })
        .then(() => {
          this.loadingData = false;
        })
        .then(() => {
          return this.$nextTick();
        })
        .then(() => {
          this.processVentas();
        });
    },
  },
  beforeCreate: function () {},
  beforeMount: function () {
    this.getCategories();
    this.getFamilias();
    this.getCajas();
    this.getCashiers();
    this.$emit("useNav", true);
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
